import { render, staticRenderFns } from "./CollapseArrow.vue?vue&type=template&id=02836278&"
import script from "./CollapseArrow.vue?vue&type=script&lang=js&"
export * from "./CollapseArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports